@if (visible && current) {
<div class="dyk-card">
  <div class="section-label section-label--success">Culture générale</div>
  <div class="dash-card dyk-content">
    <div class="dyk-header">
      <p class="dyk-eyebrow"><em class="fal fa-lightbulb"></em> Le saviez-vous ?</p>
      <div class="dyk-actions">
        <label class="dyk-quiz-toggle">
          <input type="checkbox" [checked]="quizMode" (change)="toggleQuizMode()" />
          <span class="dyk-quiz-toggle-track"><span class="dyk-quiz-toggle-knob"></span></span>
          <span class="dyk-quiz-toggle-label">Mode quiz</span>
        </label>
        <button
          type="button"
          class="dyk-refresh"
          (click)="anotherFact()"
          title="Un autre fait"
        >
          <em class="fal fa-sync-alt"></em>
          <span>Autre fait</span>
        </button>
        <span class="dyk-dismiss-wrap">
          <button
            type="button"
            class="btn btn-ghost btn-icon btn-sm dyk-dismiss-btn"
            (click)="openDismissMenu()"
            aria-label="Masquer ce widget"
            title="Masquer"
          >
            <em class="fal fa-times"></em>
          </button>
          @if (menuOpen) {
          <div class="dyk-dismiss-backdrop" (click)="closeDismissMenu()"></div>
          <div class="dyk-dismiss-menu">
            <button type="button" (click)="dismissForDays(1)">Masquer 1 jour</button>
            <button type="button" (click)="dismissForDays(7)">Masquer 1 semaine</button>
            <button type="button" (click)="dismissForever()">Masquer définitivement</button>
          </div>
          }
        </span>
      </div>
    </div>
    <p class="dyk-question">{{ current.question }}</p>

    @if (!quizMode) {
    <div class="dyk-answer">
      <em class="fal fa-check-circle"></em>
      <span>{{ current.choices[current.correctIndex] }}</span>
    </div>
    <p class="dyk-explanation">{{ current.explanation }}</p>
    } @else {
    <div class="dyk-quiz-choices">
      @for (choice of current.choices; track $index) {
      <button
        type="button"
        class="dyk-quiz-choice"
        [class.correct]="answered && $index === current.correctIndex"
        [class.incorrect]="
          answered && $index === selectedIndex && $index !== current.correctIndex"
        [disabled]="answered"
        (click)="selectAnswer($index)"
      >
        {{ choice }}
      </button>
      }
    </div>
    @if (answered) {
    <div
      class="dyk-quiz-feedback"
      [class.is-correct]="selectedIndex === current.correctIndex"
    >
      <p class="dyk-quiz-feedback-title">
        @if (selectedIndex === current.correctIndex) {
        <em class="fal fa-check-circle"></em> Bonne réponse !
        } @else {
        <em class="fal fa-times-circle"></em> Pas tout à fait.
        }
      </p>
      <p class="dyk-explanation">{{ current.explanation }}</p>
      <button (click)="nextQuestion()" class="btn btn-primary btn-sm dyk-quiz-next-btn" type="button">
        Question suivante <em class="fal fa-arrow-right"></em>
      </button>
    </div>
    }
    }
    <p class="dyk-privacy-note">Les réponses ne sont ni enregistrées ni transmises.</p>
  </div>
</div>
}
